export default "__VITE_ASSET__cc384f61__"